var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "data-visualisation-tab dashboard-tab" }, [
    _c("div", { staticClass: "va-row" }, [
      _c("div", { staticClass: "flex md6 xs12" }, [
        _c(
          "div",
          { staticClass: "chart-container" },
          [
            _c("vuestic-chart", {
              attrs: { data: _vm.donutChartData, type: "donut" },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex md6" },
        [
          _c("vuestic-data-table", {
            attrs: {
              apiMode: _vm.apiMode,
              tableData: _vm.tableData,
              tableFields: _vm.tableFields,
              itemsPerPage: _vm.itemsPerPage,
              onEachSide: _vm.onEachSide,
              sortFunctions: _vm.sortFunctions,
              dataModeFilterableFields: _vm.dataModeFilterableFields,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }